


















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import FormItem from '@/components/Money/Formltem.vue';
import Button from '@/components/Button.vue';

@Component({
    components: {Button, FormItem}
})
export default class EditLabel extends Vue {
    get currentTag() {
        return this.$store.state.currentTag;
    }

    created() {
        const id = this.$route.params.id;
        this.$store.commit('fetchTags');
        this.$store.commit('setCurrentTag', id);
        if (!this.currentTag) {
            this.$router.replace('/404');
        }
    }

    update(name: string) {
        if (this.currentTag) {
            this.$store.commit('updateTag', {id: this.currentTag.id, name});
        }
    }

    remove() {
        if(this.currentTag){
            this.$store.commit('removeTag',this.currentTag.id)
        }
    }

    goBack() {
        this.$router.back();
    }
}
